import { createFileRoute } from '@tanstack/react-router'
import Modules from '@/features/class'

export const Route = createFileRoute('/_authenticated/class/')({
  component: Modules,
})
